var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.htmlData)}},[_vm._v(" "+_vm._s(_vm.htmlData)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }